<template>
  <div class="pb-section-container margin-top-16">
    <div
      :class="[
        'pbs-header-container',
        active ? 'active' : null,
      ]"
    >
      <button
        v-if="finishedSection.includes('planName') && !active"
        type="button"
        class="pbs-done-button"
        @click="changeActiveStepIdx(index)"
      >
        Edit
      </button>
      <button
        v-else-if="!active"
        type="button"
        class="pbs-button"
        @click="changeActiveStepIdx(index)"
      >
        Start
      </button>
      <button
        v-else
        type="button"
        class="pbs-close-button"
        @click="changeActiveStepIdx(-1)"
      >
        <img src="@shared/assets/img/setting/chevron-up.svg" alt="Close">
      </button>
      <div class="pbs-header">
        Name of plan
      </div>
      <div
        v-if="finishedSection.includes('planName')"
        class="pbs-header-right-container"
      >
        <div class="pbs-check-container">
          <img src="@shared/assets/img/general/check-white.png" alt="Complete">
        </div>
      </div>
    </div>
    <div
      :class="[
        'pbs-body-container name-section',
        active ? 'active' : null,
      ]"
    >
      <div class="pbs-body">
        Customize your plan below.
      </div>
      <div class="pbs-input-container">
        <label
          class="pbs-input-label"
          for="name"
        >
          Name:
        </label>
        <input
          v-model="name"
          class="pbs-input"
          placeholder="30 characters max"
          maxlength="30"
        >
      </div>
      <div class="pbs-button-container">
        <button
          type="button"
          class="pbs-grey-button"
          :disabled="name.trim().length === 0"
          @click="handleContinue"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NamePlan',
  props: {
    editing: Boolean,
    index: Number,
    active: Boolean,
    changeActiveStepIdx: Function,
    plan: Object,
    updatePlan: Function,
    finishedSection: Array,
    markUnfinishedSection: Function,
    markFinishedSection: Function,
  },
  data() {
    return {
      name: '',
    };
  },
  watch: {
    plan(updatedPlan) {
      this.name = updatedPlan.name;
    },
    name(updatedName) {
      if (this.editing || this.finishedSection.includes('planName')) {
        if (this.plan.name !== updatedName) {
          this.markUnfinishedSection('planName');
        } else {
          this.markFinishedSection('planName');
        }
      }
    },
  },
  methods: {
    handleContinue() {
      this.changeActiveStepIdx(this.index + 1);
      const newPlan = {
        ...this.plan,
        name: this.name,
      };
      this.updatePlan(newPlan, 'planName');
    },
  },
};
</script>

<style lang="scss">

.pb-section-container {
  .pbs-header-container {
    padding: 10px;
    border-radius: 4px;
    border: 1px solid $N5;
    display: flex;
    align-items: center;

    &.active {
      border-bottom: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    .pbs-button {
      background-color: #DBE2F8;
      padding: 2px 18px;
      font-size: 0.625em;
      font-weight: 500;
      color: $N90;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      margin-right: 8px;
    }

    .pbs-done-button {
      background-color: #E3FCEF;
      padding: 2px 18px;
      font-size: 0.625em;
      font-weight: 500;
      color: $N90;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
      margin-right: 8px;
    }

    .pbs-close-button {
      width: 19px;
      height: 19px;
      background-color: $N5;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
    }

    .pbs-header {
      font-size: 1em;
      font-weight: 500;
      color: $N90;
    }

    .pbs-header-right-container {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .pbs-check-container {
        background-color: #4CD87D;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        @media (min-width: 1700px) {
          width: 20px;
          height: 20px;
        }

        img {
          width: 50%;
        }
      }
    }
  }

  .pbs-body-container {
    transition: all 250ms ease-out;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    padding: 0 36px;

    &.active {
      opacity: 1;
      border: 1px solid $N5;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      padding: 10px 36px 26px;

      &.name-section {
        max-height: 200px;
      }

      &.pricing-section {
        max-height: 580px;

        &.larger {
          max-height: 1420px;
        }
      }

      &.detail-section {
        max-height: 780px;
      }

      &.signup-section {
        max-height: 230px;

        @media (min-width: 1700px) {
          max-height: 200px;
        }

        &.medium {
          max-height: 370px;
        }

        &.larger {
          max-height: 480px;
        }
      }

      &.exclusion-section {
        max-height: 400px;
      }
    }

    .pbs-sub-body-container {
      transition: all ease 250ms;

      &.show {
        height: auto;
        display: inherit;
      }

      &.hide {
        display: none;
        height: 0;
      }
    }

    .pbs-body {
      font-size: 0.75em;
      color: $N90;
      margin-bottom: 14px;
    }

    .pbs-title-container {
      display: flex;
      align-items: center;

      .pbs-title {
        font-size: 0.875em;
        color: $NBLUE110;
        font-weight: 500;
        margin-right: 4px;
      }

      .pbs-tooltip-container {
        position: relative;
        display: flex;
        align-items: center;

        .pbs-help-button {
          &:hover {
            &+.pbs-tooltip {
              opacity: 1;
            }
          }
        }

        .pbs-tooltip {
          opacity: 0;
          position: absolute;
          bottom: -25px;
          left: 19px;
          width: 350px;
          font-size: 0.75em;
          color: $N80;
          background-color: #E3FCEF;
          padding: 4px 10px;
          transition: opacity 250ms ease-in;
        }
      }

      .pbs-help-button {
        width: 17px;
        height: 17px;
        background-color: $N90;
        color: $WHITE;
        font-size: 0.6em;
        border-radius: 50%;
        font-weight: 700;
        padding-top: 1px;
      }
    }

    .pbs-dark-title {
      font-size: 0.875em;
      color: $N90;
      font-weight: 500;
      margin-right: 4px;
    }

    .pbs-select-container {
      display: flex;
      flex-direction: column;
      margin-bottom: 8px;
      position: relative;
    }

    .pbs-select {
      background: rgba(9, 30, 66, 0.04);
      border-radius: 2px;
      width: 30%;
      font-size: 0.625em;
      height: 17px;
      padding-left: 4px;
      background: url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat right rgba(9, 30, 66, 0.04);
      background-position: 97% 4px;
      background-size: 10px 8px;
    }

    .pbs-input-container {
      display: flex;
      flex-direction: column;

      &:not(:last-child) {
        margin-bottom: 8px;
      }

      .pbs-input-label {
        display: flex;
        align-items: center;
        font-size: 0.75em;
        color: $N90;

        &.bold {
          font-weight: 700;
        }

        img {
          margin-right: 2px;
        }
      }

      .pbs-input {
        border: 1px solid $N10;
        border-radius: 4px;
        width: 70%;
        height: 28px;
        padding-left: 4px;
        font-size: 0.75em;

        &.width-20 {
          width: 20%;
        }
      }

      .pbs-input-suffix {
        font-size: 0.75em;
        color: $N60;
        margin-left: 4px;
      }
    }

    .pbs-radio-container {
      display: flex;
      align-items: center;
      position: relative;

      &:first-child {
        margin-right: 8px;
      }

      label {
        margin-left: 6px;
        font-size: 0.75em;
        color: $N80;
      }
    }

    .pbs-center-input {
      width: 38px;
      height: 21px;
      border: 1px solid $N10;
      border-radius: 3.63303px;
      text-align: center;
      font-size: 0.75em;
    }

    .pbs-checkbox-container {
      display: flex;
      align-items: center;
      cursor: pointer;

      .pbs-checkbox {
        width: 14px;
        height: 14px;

        &[disabled]+.pbs-checkbox-label {
          color: $N10;
        }
      }

      .pbs-checkbox-label {
        margin-left: 6px;
        font-size: 0.6875em;
        color: $N70;
      }
    }

    .pbs-sub-header {
      font-size: 0.75em;
      color: $N90;
      margin-bottom: 8px;
      font-weight: 400;

      &.bold {
        font-weight: 700;
      }

      &.gray {
        color: $N60;
      }

      a {
        color: $NBLUE110;
        text-decoration: underline;
      }
    }

    .pbs-sub-title {
      font-size: 0.75em;
      color: $N70;
      font-weight: 400;
      margin-bottom: 8px;
    }

    .pbs-input-title {
      font-weight: 700;
      font-size: 0.6875em;
      color: $N70;
    }

    .pbs-list-group {
      height: 80px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .pbs-list-group,
    .pbs-list-included-group {
      .pbs-list-group-item {
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        padding-right: 18px;

        &:hover {
          cursor: pointer;
        }

        .pbs-drag-icon {
          height: 12px;
          width: 8px;
          margin-right: 11px;
        }

        .pbs-list-item-text {
          font-size: 0.75em;
          color: $N90;
          flex: 1;
        }

        .pbs-list-order {
          width: 17px;
          height: 17px;
          border-radius: 50%;
          color: $WHITE;
          background-color: $NBLUE100;
          text-align: center;
          font-size: 0.75em;

          @media (min-width: 1700px) {
            width: 20px;
            height: 20px;
          }
        }

        .pbs-remove-btn {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: $PUNCH;
          display: flex;
          align-items: center;
          justify-content: center;

          @media (min-width: 1700px) {
            width: 16px;
            height: 16px;
          }

          img {
            width: 90%;
            height: 90%;
          }
        }
      }
    }

    .pbs-error-text {
      font-size: 0.65em;
      color: $TOMATO100;
      font-weight: 500;
      margin-top: 8px;
    }

    .pbs-footer {
      font-size: 0.75em;
      font-weight: 500;
      color: $N90;
      margin-top: 16px;
    }

    .pbs-button-container {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 14px;
    }

    .pbs-grey-button {
      font-size: 0.625em;
      color: $N90;
      background-color: #DBE2F8;
      border-radius: 2px;
      padding: 6px 12px;
      line-height: 1;

      &[disabled] {
        background-color: $N40;
        color: $WHITE;
      }
    }

    .pbs-textarea {
      width: 100%;
      border: 0.5px solid $BLACK;
      border-radius: 6px;
      height: 120px;
      resize: none;
      padding: 4px 10px;
      font-size: 0.875em;

      &[disabled] {
        background-color: $N10;
      }
    }

    .pbs-text-counter {
      text-align: right;
      font-size: 0.6875em;
      color: $N60;

      &.error-text {
        color: $TOMATO100;
        font-weight: 700;
      }
    }
  }
}
</style>
